import { SelectDropdown, Spinner, Heading, Button } from "@/common/components";
import { useEffect, useContext, useState } from "@/common/hooks";
import {
  useGetAccessorDetailsQuery,
  useLazyGetAccessorPrivilegesQuery,
  useLazyGetAccessorTransactionInfoQuery,
} from "@/service/ProfileService";
import { useGetProductManufacturersQuery } from "@/service/APIService";
import { PrivateContext } from "@/routes/PrivateRoute";
import {
  setAccessorDetails,
  setAccessorPrivileges,
  setAccessProfileId,
  setAccessProfileType,
  setIsRiccAdministrator,
  setProductSponsorId,
  setProductSponsorName,
  setShowChangeProductManufacturer,
  setRiccAdminApprovalRequiredCode,
} from "@/store/commonSlice";

const Dashboard = () => {
  const { dispatch, navigate, Routes, useSelector } =
    useContext(PrivateContext);

  const accessorDetailsFromStore = useSelector(
    (state) => state?.commonReducer?.accessorDetails
  );
  const productSponsorIdFromStore = useSelector(
    (state) => state?.commonReducer?.productSponsorId
  );

  const [productSponsorList, setProductSponsorList] = useState([]);
  const [selectedProductSponsor, setSelectedProductSponsor] = useState("");
  const [profiles, setProfiles] = useState([]);

  const { data: accessorDetails, isFetching } = useGetAccessorDetailsQuery();

  const [
    accessorTransactionInfoApi,
    { isFetching: isFetching1, error: error1 },
  ] = useLazyGetAccessorTransactionInfoQuery();

  const {
    data: allProductManufacturers,
    isFetching: isFetching2,
    error: error2,
  } = useGetProductManufacturersQuery({});

  const [accessorPrivilegesApi, { isFetching: isFetching3, error: error3 }] =
    useLazyGetAccessorPrivilegesQuery();

  const doContinue = () => {
    dispatch(setProductSponsorId(selectedProductSponsor));

    dispatch(
      setProductSponsorName(
        allProductManufacturers?.productSponsors?.find(
          (e) => e.id == selectedProductSponsor
        )?.name
      )
    );

    if (profiles && profiles?.length) {
      const accessProfileId = profiles.find(
        (e) => e.productSponsor.id == selectedProductSponsor
      )?.approveAccessProfile?.id;

      accessorPrivilegesApi(accessProfileId)
        .unwrap()
        .then((res) => {
          dispatch(setAccessorPrivileges(res));
        });

      dispatch(setAccessProfileId(accessProfileId));
    }

    navigate(Routes.productList.path);
  };

  useEffect(() => {
    if (accessorDetails) {
      dispatch(setAccessorDetails(accessorDetails));
    }
  }, [accessorDetails]);

  useEffect(() => {
    if (
      accessorDetailsFromStore &&
      accessorDetailsFromStore?.id &&
      allProductManufacturers
    ) {
      accessorTransactionInfoApi()
        .unwrap()
        .then((res) => {
          const dataAccessRuleList =
            res?.operatorId === "1000"
              ? null
              : (res?.dataAccessRuleList || []).filter(
                  (item) => item?.requestStatus !== "P"
                );

          setProductSponsorList(
            res?.accessProfile?.typeCode === "A"
              ? allProductManufacturers?.productSponsors
              : dataAccessRuleList?.map((e) => e.productSponsor)
          );

          const approveAccessProfiles = dataAccessRuleList?.filter(
            (e) => e.approveAccessProfile != null
          );
          setProfiles(approveAccessProfiles);

          if (!res?.inError && !productSponsorIdFromStore) {
            if (approveAccessProfiles && approveAccessProfiles?.length) {
              const productSponsor = approveAccessProfiles[0]?.productSponsor;
              const accessProfileId =
                approveAccessProfiles[0]?.approveAccessProfile?.id;
              const accessProfileType =
                approveAccessProfiles[0]?.approveAccessProfile?.typeCode;

              setSelectedProductSponsor(productSponsor?.id);
              dispatch(setProductSponsorId(productSponsor?.id));
              dispatch(setProductSponsorName(productSponsor?.name));
              dispatch(setAccessProfileId(accessProfileId));
              dispatch(setAccessProfileType(accessProfileType));
              dispatch(
                setRiccAdminApprovalRequiredCode(
                  approveAccessProfiles[0]?.approveAccessProfile
                    ?.riccAdmApprovalRequiredCode
                )
              );

              if (approveAccessProfiles.length === 1) {
                accessorPrivilegesApi(accessProfileId)
                  .unwrap()
                  .then((res) => {
                    dispatch(setAccessorPrivileges(res));
                  });
                dispatch(setShowChangeProductManufacturer(false));
                navigate(Routes.productList.path);
              }
            }

            if (
              res?.accessProfile &&
              res?.accessProfile?.typeCode === "A" &&
              allProductManufacturers
            ) {
              setSelectedProductSponsor(
                allProductManufacturers?.productSponsors[0].id
              );

              dispatch(setAccessProfileId("1"));
              dispatch(setIsRiccAdministrator(true));
              dispatch(setAccessProfileType("A"));
            }
          }
        });
    }
  }, [allProductManufacturers, accessorDetailsFromStore]);

  useEffect(() => {
    if (productSponsorIdFromStore) {
      setSelectedProductSponsor(productSponsorIdFromStore);
    }
  }, []);

  return (
    <section className="container-medium d-flex justify-content-center align-items-center flex-column py-5">
      {(isFetching || isFetching1 || isFetching2 || isFetching3) && <Spinner />}
      <Heading
        text="Select Configuration Settings"
        wrapperClassNames="text-center mb-4"
      />

      <SelectDropdown
        label="Product Manufacturer:*"
        id="Products"
        dropdownData={productSponsorList}
        selectClassName="w-100 py-2"
        wrapperClassName="col-md-8 col-12 mb-3"
        select={(e) => {
          setSelectedProductSponsor(e);
        }}
        value={selectedProductSponsor}
        optionId="id"
        optionLabel="name"
        ariaLabel="Product Sponsors"
      />

      <Button
        id="continue"
        text="Continue"
        wrapperClassName="col-md-4 col-12 mb-2 mx-auto"
        click={doContinue}
        disabled={error1 || error2 || error3}
      />
    </section>
  );
};

export default Dashboard;
